import { Form } from "antd";
import { useParams } from "react-router";

import { AidPreferencesTable } from "src/app/features/EmvKernelProfile/subFeatures/AidPreference/components/tables/AidPreferencesTable";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";

export const EmvKernelProfilesAidPreferencesTableField: FieldMethod = ({ field }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <AidPreferencesTable key={field.name} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
